export var ElementEvent;
(function (ElementEvent) {
    ElementEvent["MOUSE_ENTER"] = "mouseenter";
    ElementEvent["MOUSE_OVER"] = "mouseover";
    ElementEvent["MOUSE_OUT"] = "mouseout";
    ElementEvent["MOUSE_LEAVE"] = "mouseleave";
    ElementEvent["MOUSE_DOWN"] = "mousedown";
    ElementEvent["MOUSE_UP"] = "mouseup";
    ElementEvent["MOUSE_CLICK"] = "click";
    ElementEvent["MOUSE_DOUBLE_CLICK"] = "dblclick";
    ElementEvent["MOUSE_MOVE"] = "mousemove";
    ElementEvent["MOUSE_CONTEXT_MENU"] = "contextmenu";
    ElementEvent["TOUCH_START"] = "touchstart";
    ElementEvent["TOUCH_END"] = "touchend";
    ElementEvent["TOUCH_CANCEL"] = "touchcancel";
    ElementEvent["TOUCH_MOVE"] = "touchmove";
    ElementEvent["ON_WHEEL"] = "wheel";
    ElementEvent["ON_CONTEXT_MENU"] = "contextmenu";
    ElementEvent["SCROLL"] = "scroll";
    ElementEvent["CHANGE"] = "change";
    ElementEvent["INPUT"] = "input";
})(ElementEvent || (ElementEvent = {}));
export const elementEvents = () => {
    const out = [];
    Object.keys(ElementEvent).forEach((key) => {
        out.push(ElementEvent[key]);
    });
    return out;
};
